import React, { Component, Fragment } from 'react'
import './main-nav.scss'
import OnlineRetentionTouchPoint from '../Navigation/OnlineRetentionTouchPoint';

export default class MainNav extends Component {

    constructor(props){
        super(props);
        this.state = {
            active:"",
            topNavMenu:[
                {
                    id:"phone",
                    title:"phone",
                    data:[
                        {

                        }
                    ]
                },
                {
                    id:"phone2",
                    title:"phone2",
                    data:[
                        {

                        }
                    ]
                }
            ]
        }

        this.updateInputMSISDN = this.props.updateInputMSISDN;
        this.updateInputPW = this.props.updateInputPW;
        this.navDoLogin = this.props.navDoLogin;
        this.navDoLogout = this.props.navDoLogout;
        this.navShowLoginDialog = this.props.navShowLoginDialog;
        this.navHideLoginDialog = this.props.navHideLoginDialog;
        this.navFlipLoginDialog = this.props.navFlipLoginDialog;
        this.loginProfile = this.props.loginProfile;
        this.goToDtPlatform = this.props.goToDtPlatform;
        this.updateLoginMode = this.props.updateLoginMode;
        this.currentSelectedTab = this.props.currentSelectedTab;
        //this.state.isLogin = checkIsLogin();
    }

    componentDidMount(){
        //this.setState({isLogin:checkIsLogin()})
    }

    componentWillMount() {
        window.addEventListener("resize", this.resetPages.bind(this));
    }

    resetPages(){
        let theme = this.props.theme;
        if(theme.control === "ON"){
            if(document.body.clientWidth < 768){

                let domObj = document.getElementsByClassName("main-nav");
                for(let i = 0;i < domObj.length;i++){
                    domObj[i].setAttribute("style","background:url('"+theme.mobileImg+"') no-repeat;background-size:100% 100%;");
                }
            }else{
                let domObj = document.getElementsByClassName("main-nav");
                for(let i = 0;i < domObj.length;i++){
                    domObj[i].setAttribute("style","background:url('"+theme.desktopImg+"') no-repeat;background-position:50px;");
                }
            }
        }

    }

    showMenu = (menu) => {
        console.log(menu);
        //Hide Login Menu if any
        this.navHideLoginDialog();

        //Show
        if (menu.id !== this.state.active) {
            this.setState({active: menu.id})
        }
        //Hide
        else {
            this.setState({active: ''})
        }
    }

    getMenuList(){
        let isMobile = this.props.isMobile || false;
        if(isMobile)
            return;
        let menus = this.props.topNavMenu.items;
        let lang = window.THREE_REACT_APP_GLOBAL.language || "en";

        return (
            <div className={"nav-menu menus"}>
                {menus.map(menu=>{
                    return <div className={"menu"+(menu.id==this.state.active?" active":"")}>
                        <div style={{maxWidth:((menu.maxWidth||250)+'px')}} 
                            onClick={() => this.showMenu(menu)}
                            //onMouseEnter={()=> this.showMenu(menu)}
                            className={"menu-flex-block flex"+(menu.id==this.state.active?" show-menu":" hide-menu")}>

                            <h2 className={"menu-btn"}>
                                {menu.title}
                            </h2>
                        </div>
                        <div className={"menu-block flex"+(menu.id==this.state.active?" show-menu":" hide-menu")}>
                            {
                                menu.id === "2"?
                                (
                                    menu.items.map((textLink,index)=>{
                                        const subHeaderNewCustomer = lang === "en" ? "For New Customers"  : "新客戶";
                                        const subHeaderExistingCustomer = lang === "en" ? "For Existing Customers"  : "現有客戶";
                                        const {id,href,isNewWindow,label} = textLink;


                                        let linkTarget = "_self";
                                        if(isNewWindow !== undefined && isNewWindow !== null){
                                            if(isNewWindow){
                                                linkTarget = "_blank";
                                            }
                                        }


                                        if(id === "1" || id === "11"){
                                            return (
                                                <Fragment>
                                                    <div style={{paddingTop:15}} className='sub-header-label'>{id === "1" ? subHeaderNewCustomer : subHeaderExistingCustomer}</div>
                                                    <a href={href || "#"} class="text-link sub-header" target={linkTarget}>
                                                        <div className="text">{label}</div>
                                                        <svg className="svg" viewBox={"0 0 30 30"}>
                                                            <path d="M5 5 L15 15 L5 25  L15 15 Z" stroke-width="2" stroke="black"/>
                                                        </svg>
                                                    </a>
                                                </Fragment>
                                            )
                                        }

                                        return <a href={href || "#"} class="text-link sub-header" target={linkTarget}>
                                            <div className="text" style={{marginLeft: id > 100 ?"15px" : 0}}>{label}</div>
                                            <svg className="svg"
                                                viewBox={"0 0 30 30"}
                                            >
                                                <path d="M5 5 L15 15 L5 25  L15 15 Z" stroke-width="2" stroke="black"/>
                                            </svg>
                                        </a>
                                    })
                                )
                                :
                                (
                                    menu.items.map(textLink=>{

                                        const {id,href,isNewWindow,label} = textLink;

                                        let linkTarget = "_self";
                                        if(isNewWindow !== undefined && isNewWindow !== null){
                                            if(isNewWindow){
                                                linkTarget = "_blank";
                                            }
                                        }

                                        return <a href={href || "#"} class="text-link" target={linkTarget}>
                                            <div className="text" style={{marginLeft: id > 100 ?"15px" : 0}}>{label}</div>
                                            <svg className="svg"
                                                viewBox={"0 0 30 30"}
                                            >
                                                <path d="M5 5 L15 15 L5 25  L15 15 Z" stroke-width="2" stroke="black"/>
                                            </svg>
                                        </a>
                                    })
                                )
                            }

                            {
                                menu.images != null && menu.images.length > 0 && (
                                    <div style={{marginTop:10}}>
                                        {
                                            menu.images.map(image=>
                                                <a href={image.url || "#"} class="img-link mb-1" target={image.isNewWindow ? "_blank": "_self"}>
                                                    <div style={{backgroundImage:`url(${image.src})`,marginTop: 10}} />
                                                </a>
                                            )
                                        }
                                    </div>
                                )
                            }

                        </div>
                    </div>
                })}
            </div>
        )
    }

    getLogo(){
        let general = this.props.general;
        return <div class="nav-logo-block">
            <img class="nav-logo"
                 onClick={e=>window.location.href = general.homeUrl}
                 src="/assets/images/3_logo.svg" alt={general.logoAlt}></img>
        </div>
    }

    /* Desktop Login Dialog Part */

    renderMentionPoints = (mentionPoints) => mentionPoints.map(point=><li>{point.desc}</li>);

    getLoginBlock(){
        let {showLoginBlock} = this.state;
        let login = this.props.login;
        let loginBlock = this.props.login.block;

        let loginProfile = this.props.loginProfile;

        let lang = window.THREE_REACT_APP_GLOBAL.language || "en";

        let postPaidForgetPWLink = "https://www.three.com.hk/3Care/inquiryUserInfo.do?appId=setpassword&lang=" + ((lang === "en") ? "eng" : "chi");
        let prePaidForgetPWLink = lang === "en" ? "https://www.three.com.hk/prepaid/DIY/en/"  : "https://www.three.com.hk/prepaid/DIY/tc/";

        let theme = this.props.theme;
        let bgStyle = {};
        if(theme.control === "ON"){
            bgStyle = {
                background:"url('"+theme.desktopMenuImg+"') no-repeat"
            }
        }

        let currentSelectedTab = this.props.currentSelectedTab;

        let postpaidTabName = lang === "en" ? "Postpaid" : "上台客戶";
        let prepaidTabName = lang === "en" ? "DIY Prepaid" : "DIY儲值卡";
        let prepaidNote = lang === "en" ? "Email Login is only possible for DIY Prepaid SIM customers" : "電郵登入只適用於DIY儲值卡客戶";
        let prepaidNote2 = lang === "en" ? "Prepaid SIM Customer: Please send a blank SMS to 503175." : "儲值咭客戶︰請用手機發送一個空白短訊至503175.";

        if(loginProfile.isLogin === false){
            return(
                <div id={"desktopLoginBlock"} className={"login-block"+(loginProfile.loginDialogDisplay?" show-login":" hide-login")}>
                    <svg height="20" width="40">
                        <path d="M20 0 L0 20 L40 20 Z" />
                    </svg>
                    <div className={"text login-main-block flex"} style={ bgStyle }>
                        <div className={"switchLoginButtonContainer"}>
                            <div className={"col-xs-6 switchLoginModeBtn" + (currentSelectedTab === "traditional" ? " selectedSwitchLoginModeBtn" : "")}
                                 onClick={() => this.updateLoginMode("traditional")}>
                                {postpaidTabName}
                            </div>
                            <div className={"col-xs-6 switchLoginModeBtn" + (currentSelectedTab === "dt" ? " selectedSwitchLoginModeBtn" : "")}
                                 onClick={() => this.updateLoginMode("dt")}>
                                {prepaidTabName}
                            </div>
                        </div>

                        <div className="title">{loginBlock.title}</div>
                        <div className="desc">{loginBlock.desc}</div>
                        {this.props.renderCommonInputFields()}
                        <a className="forget-pw" href={currentSelectedTab === "dt" ? prePaidForgetPWLink : postPaidForgetPWLink}>{loginBlock.forgetPasswordLabel}</a>
                        <ui className="points">
                            {
                                currentSelectedTab === "dt" ? (
                                        <React.Fragment>
                                            {/* <li>{prepaidNote}</li>
                                            <li>{prepaidNote2}</li> */}
                                        </React.Fragment>
                                    ) :
                                    (<React.Fragment>

                                    </React.Fragment>)
                            }
                            {
                              loginBlock.mentionPoints != null && loginBlock.mentionPoints.length > 0  && this.renderMentionPoints(loginBlock.mentionPoints)
                            }
                        </ui>
                        <button className={"login-btn"} type="submit" onClick={() => this.navDoLogin()}>
                            {loginBlock.loginBtnLabel}
                        </button>
                    </div>
                </div>
            );
        }
        else{
            if(loginProfile.isDtAccount === true){
                return(
                    <div id={"desktopLoginBlock"} className={"login-block"+(loginProfile.loginDialogDisplay?" show-login":" hide-login")}>
                    </div>
                );
            }
            else{
                return(
                    <div id={"desktopLoginBlock"} className={"login-block"+(loginProfile.loginDialogDisplay?" show-login":" hide-login")}>
                        <svg height="20" width="40">
                            <path d="M20 0 L0 20 L40 20 Z" />
                        </svg>
                        <div className={"text login-main-block flex"} style={ bgStyle }>
                            {loginBlock.logoutMenu.map((item, index) => {
                                return(
                                    <a href={item.href} className="text-link" target={"_blank"}>
                                        <div className="text">{item.desc}</div>
                                        <svg className="svg" viewBox={"0 0 30 30"}>
                                            <path d="M5 5 L15 15 L5 25  L15 15 Z" stroke-width="2" stroke="black"/>
                                        </svg>
                                    </a>
                                );
                            })}


                            <OnlineRetentionTouchPoint loginProfile={loginProfile} />

                            <a href={"#"} onClick={() => this.navDoLogout()} className="logout-link-btn text-link">
                                {this.props.login.logoutLabel}
                            </a>

                        </div>
                    </div>
                );
            }
        }

    }

    showLoginDialog = () => {
        this.navFlipLoginDialog();
        this.setState({active:""});
    }

    getLoginIcon(){
        let isMobile = this.props.isMobile || false;

        //Mobile Case
        if(isMobile){
            return <div className={"navbar-hamburger-xs"}>
                <button type="button" className="btn-image navbar-menu"
                        onClick={e=>{
                            // open mobile menu
                            document.querySelector("#navbar-xs").classList.toggle('is-expanded');
                            document.querySelector("body").classList.toggle('overflow-hidden');
                        }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="23" viewBox="0 0 28 23" fill="none">
                        <path d="M26.5855 23H1.4145C0.633224 23 0 22.3822 0 21.62C0 20.8578 0.633224 20.24 1.4145 20.24H26.5855C27.3668 20.24 28 20.8578 28 21.62C28 22.3822 27.3668 23 26.5855 23ZM26.5855 12.88L1.4145 12.88C0.633224 12.88 -5.96046e-07 12.2622 -5.96046e-07 11.5C-5.96046e-07 10.7378 0.633224 10.12 1.4145 10.12L26.5855 10.12C27.3668 10.12 28 10.7378 28 11.5C28 12.2622 27.3668 12.88 26.5855 12.88ZM26.5855 2.76H1.4145C0.633224 2.76 0 2.14222 0 1.38C0 0.61778 0.633224 0 1.4145 0H26.5855C27.3668 0 28 0.61778 28 1.38C28 2.14222 27.3668 2.76 26.5855 2.76Z" fill="#774FDA"/>
                    </svg>
                </button>
            </div>

        }
        //Desktop Case
        else{
            // 20220118 Change Login Button Position
            
            return (
                <div className={"nav-right user"}>
                    <div className={"navSecretHide"} onClick={() => this.hideAllMenu()} />
                </div>
            );
        }

    }

    componentWillUnmount(){

    }

    hideAllMenu = () => {
        this.navHideLoginDialog();
        this.setState({active:""});
    }

    render() {
        let theme = this.props.theme;
        let bgStyle = {}
        if(theme.control === "ON"){
            if(document.body.clientWidth < 768){
                bgStyle = {
                    background:"url('"+theme.mobileImg+"') no-repeat",
                    backgroundSize: "100% 100%"
                }
            }else{
                bgStyle = {
                    background:"url('"+theme.desktopImg+"') no-repeat"
                }
            }
        }


        return (
            <div className={"main-nav"} style={ bgStyle }>
                <div className={"nav-left"}>
                    {this.getLogo()}
                    {this.getMenuList()}
                </div>
                <div className={"flex"}>
                    {this.getLoginIcon()}
                </div>
            </div>
        )
    }


}